module.exports = __webpack_public_path__ + "img/Safely-on-Your-Phone.687045d4.webp";